'use client'

import { RichText } from '@/components/RichText'

type RichTextBlockProps = {
  blockType: 'courseRichText' | 'pageRichText'
  id?: string | null
  content?: any
}

export const RichTextBlockComponent: React.FC<RichTextBlockProps> = ({ content }) => {
  if (!content) return null

  return (
    <article className="prose-content">
      <RichText data={content} enableGutter={false} enableProse={false} />
    </article>
  )
}
